export default "__VITE_ASSET__7WpVNnCX__"